import { CONSTANTS } from '@/types/enum/constants'

const getIsUserIndustrySchool = (loggedUserRoles: string[]): boolean =>
  !!loggedUserRoles?.find(value => CONSTANTS.ROLE_INDUSTRY_USER_SCHOOL === value) || false

export default getIsUserIndustrySchool
